module.exports = __webpack_public_path__ + "img/zip-icon.0b7c6a06.svg";